import {
  ref,
  useMeta,
  useContext,
  ssrRef,
  onBeforeMount,
} from '@nuxtjs/composition-api';

const usePage = (slug) => {
  const isLoading = ref(false);
  const isLoaded = ref(false);
  const page = ref(null);
  const {
    error: showErrorPage,
    ssrContext,
    $api: { pagesService },
    nuxtState,
  } = useContext();
  const error = ssrRef('false', 'error');

  const fetchPage = async () => {
    isLoading.value = true;
    try {
      const { data } = await pagesService.getPageBySlug(slug);
      page.value = data;
    } catch (_) {
      if (process.server) {
        ssrContext.res.statusCode = 404;
        error.value = 'true';
      } else showErrorPage({ statusCode: 404 });
    } finally {
      isLoaded.value = true;
      if (process.client) {
        setTimeout(() => {
          isLoading.value = false;
        }, 50);
      } else {
        isLoading.value = false;
      }
    }
  };

  useMeta(() => ({
    title: page.value?.seo_title,
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: page.value?.seo_description,
      },
      {
        property: 'og:title',
        content: page.value?.seo_og_title,
      },
      {
        property: 'og:description',
        content: page.value?.seo_description,
      },
    ],
  }));

  onBeforeMount(() => {
    if (error.value === 'true') {
      showErrorPage({ statusCode: 404 });
      nuxtState.ssrRefs.error = 'false';
    }
  });

  return {
    isLoading,
    isLoaded,
    page,
    fetchPage,
  };
};

export default usePage;
